var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCourseIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.00004 9.09242V23.5013C7.40494 22.9632 8.99696 22.6667 10.6667 22.6667C12.3365 22.6667 13.9285 22.9632 15.3334 23.5013V9.09242C14.0807 8.42214 12.4642 8.00004 10.6667 8.00004C8.86925 8.00004 7.25271 8.42214 6.00004 9.09242ZM18 9.09242V23.5013C19.4049 22.9632 20.997 22.6667 22.6667 22.6667C24.3365 22.6667 25.9285 22.9632 27.3334 23.5013V9.09242C26.0807 8.42214 24.4642 8.00004 22.6667 8.00004C20.8693 8.00004 19.2527 8.42214 18 9.09242ZM16.6667 6.78177C14.977 5.85943 12.8908 5.33337 10.6667 5.33337C8.10661 5.33337 5.72923 6.0304 3.92887 7.22651C3.55692 7.47362 3.33337 7.89053 3.33337 8.33708V25.6704C3.33337 26.1618 3.60361 26.6133 4.03663 26.8455C4.46965 27.0777 4.99528 27.0529 5.40454 26.781C6.71857 25.908 8.5695 25.3334 10.6667 25.3334C12.7639 25.3334 14.6148 25.908 15.9289 26.781C16.3759 27.078 16.9575 27.078 17.4045 26.781C18.7186 25.908 20.5695 25.3334 22.6667 25.3334C24.7639 25.3334 26.6149 25.908 27.9289 26.781C28.3381 27.0529 28.8638 27.0777 29.2968 26.8455C29.7298 26.6133 30 26.1618 30 25.6704V8.33708C30 7.89053 29.7765 7.47362 29.4045 7.22651C27.6042 6.0304 25.2268 5.33337 22.6667 5.33337C20.4426 5.33337 18.3565 5.85943 16.6667 6.78177Z",
    fill: "url(#paint0_linear_1387_13941)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1387_13941",
    x1: 3.33337,
    y1: 21.8029,
    x2: 30.8246,
    y2: 18.5178,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05456D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A7AC0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourseIcon);
export default __webpack_public_path__ + "static/media/course-icon.afb7f37b754b2bccc306e44ea76f82c0.svg";
export { ForwardRef as ReactComponent };